import { render, staticRenderFns } from "./search-order-history.vue?vue&type=template&id=97ab7582"
import script from "./search-order-history.vue?vue&type=script&lang=js"
export * from "./search-order-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports